<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { redirect } from './utils/redirect'

const props = defineProps<{ showOnly: string; activeTabs: string }>()

onBeforeMount(() => {
  // TODO: the redirect is temporary, remove when the all client migrate a new routes
  redirect(props)
})
</script>

<template>
  <RouterView />
</template>

<style scoped></style>
